import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { contactViewPipe } from '../pipes/phone-view.pipe';

import { SessionStorageService } from "./../shared/services/session-storage.service";
import { SharedService } from '../shared/services/shared.service';


@Component({
    template: require('./virtual-consultation-success-page.component.html'),
    styles: [require('./virtual-consultation-success-page.component.less')],
    preserveWhitespaces: true,
    providers: [contactViewPipe]
})

export class VCSuccessPageComponent implements OnInit {

    constructor(
        private _router: Router,
        private _sessionStorageService: SessionStorageService,
        private _sharedService:SharedService,
        private contactViewPipe: contactViewPipe,
    ) {}

    isMobile: boolean = false;
    token: any;
    _patientFile: any = {};
    contact_number: any;
    successText: any = '';
    successTextParaSecond: any = '';
    successTextParaThird: any = '';
    addressBarHidden: boolean;
    
    vc_type: any = '';
    // mobileNumber: any;

    ngOnInit() {
        this.addressBarHidden = (window.innerHeight > document.documentElement.offsetHeight) ? true : false;

        this.isMobile = this._sharedService.isMobileOrTabletDevice();
        this._sessionStorageService.readItem('vcType').then((data: any) => {
            if(data) {
                this.vc_type = data;
                if(this.vc_type === "vc-new-consultation"){
                    this.successText = 'SUCCESS_TEXT_NC';
                    this.successTextParaSecond = 'SUCCESS_TEXT_NC_PARA_SECOND';
                    this.successTextParaThird  = 'SUCCESS_TEXT_NC_PARA_THIRD';
                }
                if(this.vc_type === "vc-progress-checkup"){
                    this.successText = 'SUCCESS_TEXT_PC';
                    this.successTextParaSecond = 'SUCCESS_TEXT_RC_PARA_SECOND';
                    this.successTextParaThird  = 'SUCCESS_TEXT_RC_PARA_THIRD';
                }
                if(this.vc_type === "vc-retainer-checkup"){
                    this.successText = 'SUCCESS_TEXT_RC';
                    this.successTextParaSecond = 'SUCCESS_TEXT_RC_PARA_SECOND';
                    this.successTextParaThird  = 'SUCCESS_TEXT_RC_PARA_THIRD';
                }
                if(this.vc_type === "vc-emergency-checkup"){
                    this.successText = 'SUCCESS_TEXT_DC';
                    this.successTextParaSecond = 'SUCCESS_TEXT_DC_PARA_SECOND';
                    this.successTextParaThird  = 'SUCCESS_TEXT_DC_PARA_THIRD';
                }
            }
        });
        this._sessionStorageService.readItem('patientFile').then((data: any) => {
            if (data) {
                this._patientFile = data;
                this.token = data.token;

                // convert phone format to xxx-xxx-xxxx for USA & Canada
                if (data.location_contact_number && (data.countryCode === 'US' || data.countryCode === 'CA')) {
                    this.contact_number = this.contactViewPipe.transformNational(data.location_contact_number, data.countryCode);
                } else {
                    this.contact_number = this._sharedService.formatPhone(data.location_contact_number, data.countryCode);
                }

                this._sessionStorageService.clearItems();
                // this.mobileNumber = data.phone_number;
            }
        })
    }

    // done() {
    //     this._sessionStorageService.clearItems();
    //     this._router.navigate(['https://www.google.com/_/chrome/newtab'])
    //     // this._router.navigate(['vc-start/' + this.token]);
    // }
}